import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Col } from "reactstrap";
import { BASE_URL } from "../../../../Config/axiosInstance";

export default function NewlyAdded() {
  const { newlyAddedStores } = useSelector((state) => state.Stores);

  return (
    <>
      <div className="carousel pt-0 pb-0" id="recommended-res">
        <div class="three" style={{ padding: "4vh 0" }}>
          <h1>Newly Added Stores</h1>
        </div>
        <Row>
          {newlyAddedStores.slice(0, 10).map((store, i) => {
            return (
              <Col xl="2" sm="4" id="brands-index2" style={{background:"#fff", padding:"3% 2%",boxShadow: "3px 3px 6px 0px #CCDBE8 inset, -3px -3px 6px 1px rgba(255,255,255,0.5) inset"}}>
                <Link
                  to={`/store/${store.slug}`}
                  style={{ margin: 0, padding: 0 }}
                >
                  <img
                    src={`${BASE_URL}/${store?.image}`}
                    alt="store"
                    width="100%"
                    height="120px"
                    loading="lazy"
                    style={{ objectFit: "contain", borderRadius: "20px" }}
                    ata-toggle="tooltip" data-placement="top" title={store?.slug}
                  />
                </Link>
              </Col>
            );
          })}
        </Row>
        <br />
      </div>
    </>
  );
}
